(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["opd-dart-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opd-dart-finder')) {
  customElements.define('opd-dart-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const form = this.querySelector('form');
      form.addEventListener('submit', () => {
        form.action = this.querySelector('[data-opd-shape]').value;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opd-latest-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (section) => {
    if (section.dataset.videoReady) return;
    section.dataset.videoReady = 'true';
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const cards = [...section.querySelectorAll('[data-opd-video-card]')];
    const reset = (card, focus = false) => {
      card.querySelector('iframe')?.remove();
      card.querySelector('[data-opd-video-load]').hidden = false;
      card.querySelector('[data-opd-video-close]').hidden = true;
      card.querySelector('[data-opd-video-status]').textContent = '';
      card.removeAttribute('data-video-open');
      if (focus) card.querySelector('[data-opd-video-load]').focus();
    };
    for (const card of cards) {
      const button = card.querySelector('[data-opd-video-load]');
      const close = card.querySelector('[data-opd-video-close]');
      const poster = button.querySelector('img');
      const updatePoster = () => button.classList.toggle('is-thumbnail-unavailable', poster.complete && poster.naturalWidth === 0);
      poster.addEventListener('error', updatePoster, options);
      poster.addEventListener('load', updatePoster, options);
      if (poster.complete) updatePoster();
      const id = card.dataset.videoId;
      if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) continue;
      button.disabled = false;
      button.addEventListener('click', () => {
        if (card.querySelector('iframe')) return;
        cards.forEach(other => { if (other !== card) reset(other); });
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=0&controls=1&playsinline=1&rel=0`;
        frame.title = button.dataset.playerTitle;
        frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.tabIndex = 0;
        frame.addEventListener('load', () => {
          if (!frame.isConnected) return;
          card.querySelector('[data-opd-video-status]').textContent = section.dataset.playerOpened;
        }, { once: true, signal: abort.signal });
        button.hidden = true;
        card.querySelector('[data-opd-video-media]').append(frame);
        close.hidden = false;
        card.dataset.videoOpen = 'true';
        frame.focus();
      }, options);
      close.addEventListener('click', () => reset(card, true), options);
    }
    section._opdVideosCleanup = () => {
      cards.forEach(card => reset(card));
      abort.abort();
      delete section.dataset.videoReady;
    };
  };
  const scan = (scope = document) => scope.querySelectorAll('[data-opd-latest-videos]').forEach(initialise);
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-opd-latest-videos]').forEach(section => section._opdVideosCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opd-range-spotlight"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (root.dataset.spotlightReady) return;
    const slides = [...root.querySelectorAll('[data-spotlight-slide]')];
    const track = root.querySelector('.opd-spotlight__track');
    const media = root.querySelector('.opd-spotlight__media');
    const campaign = root.querySelector('.opd-spotlight__campaign') || media;
    const dartTrack = root.querySelector('.opd-spotlight__dart-track');
    const darts = [...root.querySelectorAll('[data-spotlight-dart]')];
    const controls = root.querySelector('.opd-spotlight__controls');
    const dots = [...root.querySelectorAll('[data-spotlight-select]')];
    const cards = [...root.querySelectorAll('[data-spotlight-card]')];
    const pause = root.querySelector('[data-spotlight-pause]');
    const heading = root.querySelector('h2[data-spotlight-heading]');
    const description = root.querySelector('p[data-spotlight-description]');
    const copyRegion = root.querySelector('.opd-spotlight__active-copy');
    if (slides.length < 2 || !track || !pause) return;
    root.dataset.spotlightReady = 'true';
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let current = 0;
    let direction = 1;
    let timer;
    let userPaused = Boolean(window.Shopify && Shopify.designMode);
    let keyboardPaused = false;
    let keyboardMode = false;
    let lastPointerType = '';
    let hovered = false;
    let focused = false;
    let pointerActive = false;
    let visible = false;
    let start = null;
    let suppressClick = false;
    let manualAnnouncement = false;
    const clear = () => window.clearTimeout(timer);
    const isPaused = () => userPaused || keyboardPaused || motion.matches;
    const updatePause = () => {
      if (copyRegion) copyRegion.setAttribute('aria-live', isPaused() || manualAnnouncement ? 'polite' : 'off');
      root.dataset.reducedMotion = String(motion.matches);
      pause.hidden = motion.matches;
      const label = isPaused() ? pause.dataset.resumeLabel : pause.dataset.pauseLabel;
      pause.setAttribute('aria-label', label);
      pause.setAttribute('title', label);
      pause.setAttribute('aria-pressed', String(isPaused()));
      pause.classList.toggle('is-paused', isPaused());
    };
    const schedule = () => {
      clear();
      if (isPaused() || hovered || focused || pointerActive || !visible || document.hidden) return;
      timer = window.setTimeout(() => {
        if (current === slides.length - 1) direction = -1;
        if (current === 0) direction = 1;
        select(current + direction);
      }, 8000);
    };
    const select = (index, manual = false) => {
      current = Math.max(0, Math.min(slides.length - 1, index));
      manualAnnouncement = manual;
      updatePause();
      const selected = slides[current];
      track.style.transform = `translateX(-${current * 100}%)`;
      if (dartTrack) dartTrack.style.transform = `translateX(-${current * 100}%)`;
      if (heading) heading.textContent = selected.dataset.spotlightHeading || selected.getAttribute('aria-label');
      if (description) description.textContent = selected.dataset.spotlightDescription || '';
      slides.forEach((slide, i) => { slide.inert = i !== current; slide.setAttribute('aria-hidden', String(i !== current)); });
      darts.forEach(dart => { const active = dart.dataset.spotlightDart === selected.dataset.spotlightSlide; dart.inert = !active; dart.setAttribute('aria-hidden', String(!active)); });
      dots.forEach(dot => dot.setAttribute('aria-pressed', String(dot.dataset.spotlightSelect === selected.dataset.spotlightSlide)));
      cards.forEach(card => card.classList.toggle('is-active', card.dataset.spotlightCard === selected.dataset.spotlightSlide));
      schedule();
    };
    const selectId = id => select(slides.findIndex(slide => slide.dataset.spotlightSlide === id), true);
    dots.forEach(dot => dot.addEventListener('click', () => selectId(dot.dataset.spotlightSelect), options));
    cards.forEach(card => {
      card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && fineHover.matches) selectId(card.dataset.spotlightCard); }, options);
      card.addEventListener('focus', () => { if (keyboardMode) selectId(card.dataset.spotlightCard); }, options);
    });
    pause.addEventListener('click', () => {
      const resume = userPaused || keyboardPaused;
      userPaused = !resume;
      if (resume) { keyboardPaused = false; hovered = false; focused = false; }
      manualAnnouncement = false;
      updatePause();
      schedule();
    }, options);
    document.addEventListener('keydown', event => {
      if (['Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].includes(event.key)) { keyboardMode = true; lastPointerType = ''; }
    }, { capture: true, signal: abort.signal });
    document.addEventListener('pointerdown', event => {
      keyboardMode = false;
      lastPointerType = event.pointerType || 'mouse';
      if (!root.contains(event.target)) return;
      pointerActive = true;
      focused = false;
      if (lastPointerType !== 'mouse') hovered = false;
      clear();
    }, { capture: true, signal: abort.signal });
    root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && fineHover.matches) { hovered = true; clear(); } }, options);
    root.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(); } }, options);
    root.addEventListener('focusin', event => {
      const keyboardFocus = keyboardMode || (!lastPointerType && event.target.matches(':focus-visible'));
      if (!keyboardFocus) return;
      focused = true;
      keyboardPaused = true;
      updatePause();
      clear();
    }, options);
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } }, options);
    media.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      keyboardPaused = true;
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length;
      select(index, true);
      dots[index].focus();
    }, options);
    media.addEventListener('pointerdown', event => {
      if (event.target.closest('button')) return;
      start = { x: event.clientX, y: event.clientY };
      suppressClick = false;
    }, options);
    media.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { suppressClick = true; select((current + (dx < 0 ? 1 : -1) + slides.length) % slides.length, true); }
    }, options);
    const releasePointer = () => { pointerActive = false; start = null; schedule(); };
    document.addEventListener('pointerup', releasePointer, options);
    document.addEventListener('pointercancel', releasePointer, options);
    media.addEventListener('dragstart', event => event.preventDefault(), options);
    media.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); suppressClick = false; } }, { capture: true, signal: abort.signal });
    document.addEventListener('visibilitychange', schedule, options);
    motion.addEventListener('change', () => { updatePause(); schedule(); }, options);
    fineHover.addEventListener('change', () => { if (!fineHover.matches) hovered = false; schedule(); }, options);
    window.addEventListener('pageshow', event => { if (event.persisted) { pointerActive = false; start = null; hovered = false; if (!keyboardMode) focused = false; schedule(); } }, options);
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting && entry.intersectionRatio >= 0.25; schedule(); }, { threshold: 0.25 });
    observer.observe(campaign);
    root.closest('.shopify-section')?.addEventListener('shopify:block:select', event => {
      const index = slides.findIndex(slide => slide.dataset.spotlightSlide === event.detail.blockId);
      if (index >= 0) select(index, true);
    }, options);
    root._opdSpotlightCleanup = () => { clear(); observer.disconnect(); abort.abort(); delete root.dataset.spotlightReady; };
    controls.hidden = false;
    root.classList.add('is-enhanced');
    select(0);
  };
  const scan = (scope = document) => scope.querySelectorAll('[data-opd-spotlight]').forEach(initialise);
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-opd-spotlight]').forEach(root => root._opdSpotlightCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opd-shopping-start"] && !Shopify.designMode) return;
  try {
    
(() => {
  function updateReviewSummary() {
    const rating = document.querySelector('#reviews .fera-averageRating-average-number[data-value]');
    const count = document.querySelector('#reviews [data-fera-rating-count-number][data-value]');
    const targets = document.querySelectorAll('[data-opd-review-summary]');
    if (!rating || !count || !targets.length) return false;
    const ratingValue = Number(rating.dataset.value);
    const countValue = Number(count.dataset.value);
    if (!(ratingValue > 0 && ratingValue <= 5 && countValue > 0)) return false;
    targets.forEach(target => {
      target.querySelector('[data-opd-review-rating]').textContent = ratingValue.toLocaleString(undefined, { maximumFractionDigits: 1 });
      target.querySelector('[data-opd-review-count]').textContent = countValue.toLocaleString();
      target.querySelector('[data-opd-review-value]').hidden = false;
      target.querySelector('[data-opd-review-fallback]').hidden = true;
    });
    return true;
  }
  function start() {
    if (!document.querySelector('[data-opd-review-summary]') || updateReviewSummary()) return;
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; if (updateReviewSummary()) observer.disconnect(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

(() => {
  const states = new WeakMap();
  const storageKey = 'opd-home-featured-dart';
  function remember(id) {
    try { sessionStorage.setItem(storageKey, id); } catch (_) {}
  }
  function prepare(visual) {
    if (states.has(visual)) return states.get(visual);
    const current = visual.querySelector('[data-opd-hero-card]');
    if (!current) return null;
    const choices = [current.cloneNode(true)];
    visual.querySelectorAll('template[data-opd-hero-choice]').forEach(template => {
      const card = template.content.querySelector('[data-opd-hero-card]');
      if (card && !choices.some(choice => choice.dataset.productId === card.dataset.productId)) choices.push(card);
    });
    const state = { choices, sequence: 0 };
    states.set(visual, state);
    return state;
  }
  function display(visual, choice, persist) {
    const state = prepare(visual);
    const current = visual.querySelector('[data-opd-hero-card]');
    if (!state || !current || !choice) return;
    const sequence = ++state.sequence;
    if (current.dataset.productId === choice.dataset.productId) {
      if (persist) remember(current.dataset.productId);
      return;
    }
    const card = document.importNode(choice, true);
    const picture = card.querySelector('img');
    if (!picture) return;
    const commit = () => {
      if (!visual.isConnected || sequence !== state.sequence) return;
      visual.querySelector('[data-opd-hero-card]').replaceWith(card);
      if (persist) remember(card.dataset.productId);
    };
    const ready = () => {
      if (typeof picture.decode === 'function') picture.decode().then(commit, commit);
      else commit();
    };
    picture.addEventListener('load', ready, { once: true });
    picture.addEventListener('error', () => { if (persist && sequence === state.sequence) remember(current.dataset.productId); }, { once: true });
    if (picture.complete && picture.naturalWidth > 0) ready();
  }
  function rotate(visual) {
    const state = prepare(visual);
    if (!state || visual.dataset.opdRotate !== 'true' || visual.dataset.opdEditor === 'true') return;
    let previous = '';
    try { previous = sessionStorage.getItem(storageKey) || ''; } catch (_) {}
    const alternatives = state.choices.filter(choice => choice.dataset.productId !== previous);
    const choices = alternatives.length ? alternatives : state.choices;
    display(visual, choices[Math.floor(Math.random() * choices.length)], true);
  }
  function initialize(scope, revisit) {
    scope.querySelectorAll('[data-opd-hero]').forEach(visual => {
      if (revisit || !states.has(visual)) rotate(visual);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document, false), { once: true });
  else initialize(document, false);
  document.addEventListener('shopify:section:load', event => initialize(event.target, false));
  document.addEventListener('shopify:block:select', event => {
    document.querySelectorAll('[data-opd-hero]').forEach(visual => {
      const state = prepare(visual);
      const choice = state && state.choices.find(card => card.dataset.opdHeroBlock === event.detail.blockId);
      if (choice) display(visual, choice, false);
    });
  });
  window.addEventListener('pageshow', event => { if (event.persisted) initialize(document, true); });
})();

  } catch(e) { console.error(e); }
})();
})();
